import styled, { css } from "styled-components";
import { Colors, Fonts, Scale } from '../../themes';
import { deviceSize } from '../../constants/deviceSize'

export const StyledDialogFilterUser = styled.div`
  margin: 30px 14px 0;
`